/* eslint-disable  @typescript-eslint/no-explicit-any */
import type {PipeMiddlewareElement, PipeMiddlewareNext} from '../../middleware-pipe';
import type { MiddlewarePipeDetails } from '../../models/middleware-pipe-details.model';
import { makeLogger } from '../../../../logger/logger';

const { debug } = makeLogger({
  pathToCurrentFile:'utils/middleware-pipe/pipes/cose/req-res-cose-mapping-apc-id.ts',
  loggersList: ['debug']
});

export const reqResCoseMappingApcId: PipeMiddlewareElement<MiddlewarePipeDetails, any> = async (
  details: MiddlewarePipeDetails,
  next: PipeMiddlewareNext<any>
): Promise<any> => {

    debug('reqResCoseMappingApcId', JSON.stringify(details.middlewareRequest.requestBody));

    try {
      const response = await next(details);

      const newResponse = {
        ...response,
        documents: response.documents.map((document) => ({
          ...document,
          idHighlighted: document.idHighlighted || document.id
        }))
      };

      return newResponse;
    } catch (error) {
      debug('Error in reqResCoseMappingApcId', error);
      throw error;
    }
};